import { Component, ViewChild, OnInit, Input, EventEmitter, Output, forwardRef, ElementRef } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  selector: 'ihm-autocomplete-chips-list',
  templateUrl: './ihm-autocomplete-chips-list.component.html',
  styleUrls: ['./ihm-autocomplete-chips-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IhmAutocompleteChipsListComponent),
      multi: true
    }
  ]
})
export class IhmAutocompleteChipsListComponent implements OnInit, ControlValueAccessor {
  @ViewChild('chipInput') chipInput: ElementRef ;

  @Output() selectionChange = new EventEmitter();

  // Sets up properties to use with chips.
  @Input() chipsList = [];
  @Input() selectable = true;
  @Input() removable = true;
  @Input() addOnBlur = true;

  // Sets up properties to use with autocomplete.
  autocompleteInput: FormControl;
  filteredOptions: Observable<any[]>;
  @Input() displayProperty = 'name';
  @Input() autoActiveFirstOption = true;
  @Input() enableHighlight = true;
  @Input() inputPlaceholder = 'Autocomplete chips message';
  @Input() optionsList = [
    { id: 1, name: 'Alternative' },
    { id: 2, name: 'Blues' },
    { id: 3, name: 'Classical' },
    { id: 4, name: 'Country' },
    { id: 5, name: 'Dance' },
    { id: 6, name: 'Electronic' },
    { id: 7, name: 'Folk' },
    { id: 8, name: 'Hip Hop' },
    { id: 9, name: 'Indie' },
    { id: 10, name: 'Inspirational' },
    { id: 11, name: 'Jazz' },
    { id: 12, name: 'Latin Music' },
    { id: 13, name: 'New Age' },
    { id: 14, name: 'Opera' },
    { id: 15, name: 'Pop' },
    { id: 16, name: 'R&B' },
    { id: 17, name: 'Soul' },
    { id: 18, name: 'Reggae' },
    { id: 19, name: 'Rock' },
    { id: 20, name: 'World' }
  ];

  propagateChange = (value: any) => {};

  ngOnInit() {
    this.autocompleteInput = new FormControl();

    this.filteredOptions = this.autocompleteInput.valueChanges.pipe(map(value => (value.length ? this.filterOptions(value) : [])));
  }

  filterOptions(value: string) {
    const optionsListWithoutSelectedChips = _.differenceWith(this.optionsList, this.chipsList, _.isEqual);

    return optionsListWithoutSelectedChips.filter(option => option.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  addChip(event: MatAutocompleteSelectedEvent): void {
    this.chipsList.push(event.option.value);
    this.clearInput();
    this.emitSelectionChange();
  }

  removeChip(selectedChip): void {
    this.chipsList = _.reject(this.chipsList, selectedChip);
    this.clearInput();
    this.emitSelectionChange();
  }

  emitSelectionChange(): void {
    this.propagateChange(this.chipsList);
    this.selectionChange.emit(this.chipsList);
  }

  clearInput(): void {
    this.chipInput['nativeElement'].blur();
    this.chipInput['nativeElement'].value = '';
    this.chipInput['nativeElement'].focus();
  }

  writeValue(value: any): void {
    if (value) {
      this.chipsList = value;
    }
  }

  registerOnChange(fn): void {
    this.propagateChange = fn;
  }

  registerOnTouched(): void {}
}
